const FIELD_ALIASES = {
  business_city: "business_city_id",
  business_region: "business_region_id",
};

export const getApiResponseData = (response) => {
  return response?.data ?? response?.response?.data;
};

export const isSuccessfulApiResponse = (response) => {
  return getApiResponseData(response)?.success === true;
};

export const mapApiFieldName = (fieldName) => {
  return FIELD_ALIASES[fieldName] ?? fieldName;
};

const collectMessages = (value, fieldName) => {
  if (value === null || value === undefined || value === false) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.flatMap((item) => collectMessages(item, fieldName));
  }

  if (typeof value === "string" || typeof value === "number") {
    return [
      {
        field: mapApiFieldName(fieldName),
        message: String(value),
      },
    ];
  }

  if (typeof value !== "object" || value.success === true) {
    return [];
  }

  const messages = Object.prototype.hasOwnProperty.call(value, "message")
    ? collectMessages(value.message, fieldName)
    : [];

  const nestedMessages = Object.entries(value).flatMap(([key, nestedValue]) => {
    if (key === "success" || key === "message") {
      return [];
    }

    return collectMessages(nestedValue, key);
  });

  return [...messages, ...nestedMessages];
};

export const extractApiErrorMessages = (errors) => {
  if (!errors || typeof errors !== "object") {
    return [];
  }

  return Object.entries(errors).flatMap(([fieldName, value]) =>
    collectMessages(value, fieldName),
  );
};

export const buildFormFieldErrors = (errorMessages, allowedFields) => {
  const allowedFieldNames = new Set(allowedFields);
  const errorsByField = new Map();

  errorMessages.forEach(({ field, message }) => {
    if (!field || !allowedFieldNames.has(field)) {
      return;
    }

    const fieldMessages = errorsByField.get(field) ?? [];
    errorsByField.set(field, [...fieldMessages, message]);
  });

  return Array.from(errorsByField, ([name, errors]) => ({ name, errors }));
};
